var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddimagesources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2233_30092)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#838382",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58702 21.4123C7.97903 21.8043 8.45004 22.0003 9.00005 22.0003L16.5663 22.0003C17.082 22.0003 17.5 21.5823 17.5 21.0666C17.5 20.5509 17.082 20.1329 16.5663 20.1329L8.90492 20.1329V12.0015H21.2106V13.1051C21.2106 13.5994 21.6113 14 22.1055 14C22.5997 14 23.0004 13.5994 23.0004 13.1051V12.0001C23.0011 11.4507 22.8054 10.98 22.4134 10.588C22.0214 10.196 21.5504 10 21.0003 10H9.00005C8.4507 9.99934 7.98003 10.195 7.58802 10.587C7.19601 10.979 7 11.45 7 12.0001V20.0002C6.99934 20.5496 7.19501 21.0203 7.58702 21.4123Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19L11.7407 14.7704C11.9192 14.5686 12.229 14.5532 12.4266 14.7364L15.291 17.3919C15.4459 17.5354 15.6763 17.561 15.8588 17.4548L17.5 16.5",
    stroke: "#838382",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 22.8391C18.7269 23.1889 18.7656 23.7668 19.1589 24.0668C19.4842 24.3149 19.9428 24.2843 20.2322 23.9952L25.7877 18.4448L25.7877 21.7932C25.7877 22.2457 26.1567 22.6113 26.6091 22.6072C27.0558 22.6032 27.4158 22.2399 27.4158 21.7932L27.4158 15.9938C27.4158 15.7211 27.1947 15.5 26.922 15.5H21.1263C20.6717 15.5 20.3036 15.8697 20.3057 16.3244C20.3077 16.7762 20.6745 17.1414 21.1263 17.1414H24.7743L19.0767 22.8391Z",
    fill: "#838382"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2233_30092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimagesources);
export default __webpack_public_path__ + "static/media/addimagesources.5ff0842b.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddimagesources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2233_30092)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#838382",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58702 21.4123C7.97903 21.8043 8.45004 22.0003 9.00005 22.0003L16.5663 22.0003C17.082 22.0003 17.5 21.5823 17.5 21.0666C17.5 20.5509 17.082 20.1329 16.5663 20.1329L8.90492 20.1329V12.0015H21.2106V13.1051C21.2106 13.5994 21.6113 14 22.1055 14C22.5997 14 23.0004 13.5994 23.0004 13.1051V12.0001C23.0011 11.4507 22.8054 10.98 22.4134 10.588C22.0214 10.196 21.5504 10 21.0003 10H9.00005C8.4507 9.99934 7.98003 10.195 7.58802 10.587C7.19601 10.979 7 11.45 7 12.0001V20.0002C6.99934 20.5496 7.19501 21.0203 7.58702 21.4123Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19L11.7407 14.7704C11.9192 14.5686 12.229 14.5532 12.4266 14.7364L15.291 17.3919C15.4459 17.5354 15.6763 17.561 15.8588 17.4548L17.5 16.5",
    stroke: "#838382",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 22.8391C18.7269 23.1889 18.7656 23.7668 19.1589 24.0668C19.4842 24.3149 19.9428 24.2843 20.2322 23.9952L25.7877 18.4448L25.7877 21.7932C25.7877 22.2457 26.1567 22.6113 26.6091 22.6072C27.0558 22.6032 27.4158 22.2399 27.4158 21.7932L27.4158 15.9938C27.4158 15.7211 27.1947 15.5 26.922 15.5H21.1263C20.6717 15.5 20.3036 15.8697 20.3057 16.3244C20.3077 16.7762 20.6745 17.1414 21.1263 17.1414H24.7743L19.0767 22.8391Z",
    fill: "#838382"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2233_30092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimagesources);
export default __webpack_public_path__ + "static/media/addimagesources.5ff0842b.svg";
export { ForwardRef as ReactComponent };